// URL base para las llamadas a la API (PlantillaPersonalWS).
//
// Por defecto es una cadena vacia, lo que hace que las llamadas usen rutas
// relativas al mismo origen desde el que se sirve la aplicacion (Apache
// proxea internamente /PlantillaPersonalWS hacia GlassFish en localhost:8080).
// Esto evita depender de un dominio externo (servicios.plantillasdestmorelos.gob.mx)
// y elimina el salto de ida y vuelta a internet para consultar la API.
//
// Se puede sobreescribir con la variable de entorno REACT_APP_API_BASE_URL,
// util por ejemplo en desarrollo local (react-scripts start) sin Apache
// delante, apuntando directo a "http://localhost:8080".
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
